import {Component, Inject, signal} from '@angular/core';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheet} from '@angular/material/bottom-sheet';
import {ClosableBottomSheetComponent, ClosableBottomSheetHandleComponent, MoneyFormatPipe} from 'shared-lib';
import {UserCampaignService} from '../../services/user-campaign.service';
import {UserReward} from '../../services/models/user-reward';
import {TranslocoDirective} from '@jsverse/transloco';
import {MatButton} from '@angular/material/button';
import {UserService} from '../../services/user.service';

@Component({
  selector: 'app-user-rewards-list-slide-in',
  templateUrl: './user-rewards-list-slide-in.component.html',
  styleUrl: './user-rewards-list-slide-in.component.scss',
  imports: [
    ClosableBottomSheetHandleComponent, MoneyFormatPipe, TranslocoDirective, MatButton
  ]
})
export class UserRewardsListSlideInComponent extends ClosableBottomSheetComponent {

  campaigns = signal<UserReward[]>([]);

  constructor(private userService: UserService, @Inject(MAT_BOTTOM_SHEET_DATA) public data: CampaignsRewardsListComponentData,
              userCampaignService: UserCampaignService, bottomSheet: MatBottomSheet) {
    super(bottomSheet);
    userCampaignService.getUserRewardsList().subscribe(result => this.campaigns.set(result));
  }

  protected withdraw(): void {
    this.userService.withdraw().subscribe(() => {
      super.close({withdrawn: true} as CampaignsRewardsListResultData);
    });
  }
}

export interface CampaignsRewardsListComponentData {
  rewardsSum: number;
}

export interface CampaignsRewardsListResultData {
  withdrawn: boolean;
}
